<template>
  <v-app-bar
    app
    color="primary"
    dark
  >
    <div class="d-flex align-center">
      <v-img
        alt="Escut de l'ajuntament de Caldes de Malavella"
        class="shrink mr-2"
        contain
        src="img/logo.png"
        transition="scale-transition"
        width="40"
      />

      <span class="text--white text-h6">
        Ajuntament de Caldes de Malavella
      </span>
    </div>

    <v-spacer></v-spacer>

    <UpdatedClock
      v-if="width >= 600"
    />

    <v-progress-linear
      :active="!!loading"
      :indeterminate="true"
      absolute
      bottom
      color="white"
    ></v-progress-linear>
  </v-app-bar>
</template>


<script>
 import { mapState } from 'vuex';
 import UpdatedClock from '@/components/UpdatedClock';

 export default {
   name: 'App',

   components: {
     UpdatedClock,
   },

   data: () => ({
     //
   }),

   computed: {
     ...mapState(['loading']),

     title() {
       return this.$route.name;
     },

     width() {
       return document.body.clientWidth;
     },
   },
 };
</script>

<style>
 v-app-bar-title__placeholder {
   text-overflow: clip;
 }
</style>
